import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import { URL_PROFILE } from "../../config/config";
import { LogoIcon, EyeIcon } from "../utils/svg";
import { LogoTextIcon } from "../utils/logo-text";
import Accessibility from "./Accessibility";
import { fetchAccessibility, getAccessibilitySize } from "../../actions/global";
import { ACCESSIBILITY_OPEN_CLASS } from "../../constants/global";

function Header() {
  const dispatch = useDispatch();

  const { accessibility } = useSelector((state) => state.global);

  const [isAccessibilityToggled, toggleAccessibility] = useState(accessibility);

  useEffect(() => {
    if (isAccessibilityToggled) {
      document.body.classList.add(ACCESSIBILITY_OPEN_CLASS);
    } else {
      const classes = document.body.className.split(" ").filter((c) => !c.startsWith("accessibility-"));
      document.body.className = classes.join(" ").trim();
    }
  }, [isAccessibilityToggled]);

  useEffect(() => {
    if (getAccessibilitySize() && !isAccessibilityToggled) {
      toggleAccessibilityBtn();
    }
  }, []);

  const toggleAccessibilityBtn = () => {
    dispatch(fetchAccessibility(!accessibility));
    toggleAccessibility(!accessibility);
  };

  const handleAccessibility = (e) => {
    e.preventDefault();
    toggleAccessibilityBtn();
  };

  return (
    <>
      {isAccessibilityToggled && <Accessibility stateAccessibility={toggleAccessibilityBtn} />}

      <div className="header-section">
        <header className="header">
          <Link className="header__logo" href="/">
            <i className="header__logo-icon header__logo-icon_mobile">
              <LogoIcon />
            </i>
            <i className="header__logo-icon">
              <LogoTextIcon />
            </i>
          </Link>

          <div className="header__buttons">
            {!isAccessibilityToggled && (
              <Link className="header__btn" href="/accessibility" onClick={handleAccessibility} itemProp="copy">
                <div className="header__btn-icon">
                  <EyeIcon />
                </div>
                <div className="header__btn-label">Версия для слабовидящих</div>
              </Link>
            )}

            <a className="header__btn btn btn_primary" href={`${URL_PROFILE}/register`} target="_blank" rel="noopener noreferrer">
              Начать обучение
            </a>
          </div>
        </header>
      </div>
    </>
  );
}

export default Header;
